module.exports = __webpack_public_path__ + "static/img/novas_demandas.b2ea03e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/novas_demandas.png
// module id = dYGt
// module chunks = 0